module.exports = __webpack_public_path__ + "img/1720x750px-Iroda.ccdcfeff.jpg";